import {
  IAdminOrganizationCreateNewPayload,
  IAdminOrganizationDetails,
  IAdminOrganizationEditPayload,
  IAdminOrganizationsSearchResult,
} from '@interfaces/adminOrganizations';
import { IFetchListRequestProps } from '@interfaces/common';

import { apiUrls } from './urls';
import { get, post, put } from './utils';

export const adminSearchOrganizations = (payload: IFetchListRequestProps) =>
  post<IAdminOrganizationsSearchResult>(apiUrls.organizations.search, payload);

export const getAdminOrganizationDetails = (organizationId: number) =>
  get<IAdminOrganizationDetails>(`${apiUrls.organizations.details}/${organizationId}`);

export const adminCreateNewOrganization = (payload: IAdminOrganizationCreateNewPayload) =>
  post(apiUrls.organizations.create, payload);

export const adminEditOrganization = (payload: IAdminOrganizationEditPayload) =>
  put(apiUrls.organizations.update, payload);

export const adminActivateOrganization = (organizationId: number) =>
  post(`${apiUrls.organizations.reactivate}/${organizationId}`);

export const adminDeactivateOrganization = (organizationId: number) =>
  post(`${apiUrls.organizations.deactivate}/${organizationId}`);
